<template>
  <div class="filter-box">
    <!-- 表单 -->
    <div class="filter-form">
      <el-form :inline="true" labelWidth="85px">
        <el-form-item label="设备型号：" label-width="90px">
          <ml-input
            placeholder="请输入设备型号"
            v-model="formParams.model"
            clearable
          ></ml-input>
        </el-form-item>
        <el-form-item label="最新版本类型：" label-width="110px">
          <ml-select
            :options="versionTypes"
            v-model="formParams.upgradeType"
            placeholder="请选择最新版本类型"
            clearable
          >
          </ml-select>
        </el-form-item>
        <el-form-item label="最新版本上传时间：" label-width="140px">
          <ml-date-time
            startPlaceholder="版本上传开始时间"
            endPlaceholder="版本上传结束时间"
            v-model:startTimeValue="formParams.upgradeStartTime"
            v-model:endTimeValue="formParams.upgradeEndTime"
          ></ml-date-time>
        </el-form-item>

        <el-form-item>
          <ml-button type="" @handleClick="submit">搜索</ml-button>
          <ml-button type="primary" @handleClick="reset"> 重置 </ml-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { versionOpts } from "@/utils/options";

const emits = defineEmits(["submit", "reset"]);

/* 最新版本类型 */
const versionTypes = [
  {
    label: "全部",
    value: "",
  },
  ...versionOpts(),
];

// 默认数据
const defaultParams = () => ({
  model: "",
  upgradeType: "",
  upgradeStartTime: "",
  upgradeEndTime: "",
});
const formParams = reactive(defaultParams());

const submit = () => {
  emits("submit", formParams);
};

const reset = () => {
  const defaultData = defaultParams();
  for (let i in defaultData) {
    formParams[i] = defaultData[i];
  }
  emits("reset", defaultData);
};

/* 设置筛选参数并查询 */
const setFilterParams = (params) => {
  Object.assign(formParams, params);
  setTimeout(() => {
    submit();
  });
};

// 获取筛选参数
const getFilterParams = () => formParams;

defineExpose({
  setFilterParams,
  getFilterParams,
  submit,
});
</script>

<style lang="scss" scoped>
.filter-form {
  user-select: none;
}
</style>
